<template>
  <div class="page">
    <header class="navbar">
      <div class="navbar__left">
        <router-link class="logo__wrp" to="/doc">
          <img src="@/assets/images/logo.png" />
          <span class="logo__title">云系统帮助中心</span>
        </router-link>
      </div>
    </header>
    <div class="page__bd">
      <div class="search-wrp">
        <div class="search-bar">
          <search-box v-model="keyword" />
        </div>
      </div>
      <div class="search-list">
        <h3 class="result__tips">{{page.totalElements}}个相关结果</h3>
        <ul class="reco__list">
          <li class="reco__item" v-for="article in page.content" :key="article.id">
            <router-link
              :to="'/doc/'+article.projectCode+'/'+article.itemCode"
              class="reco-item__link"
            >
              <div class="reco-item__hd">
                <h5 v-html="article.itemName"></h5>
                <span class="reco-item__group">{{article.projectName}}</span>
              </div>
              <div class="reco-item__bd">
                <div class="reco-item__desc" v-html="article.brief"></div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBox from "@/components/SearchBox.vue";

export default {
  props: {
    keyword: String
  },
  data() {
    return {
      number: 1,
      size: 10,
      blength: 180,
      page: {
        totalElements: 0,
        content: []
      }
    };
  },
  components: {
    SearchBox
  },
  created() {
    var keyword = this.keyword;
    if (keyword) {
      this.onSearch(keyword);
    }
  },
  watch: {
    keyword(val) {
      if (val) {
        this.onSearch(val);
      } else {
        this.page = {
          totalElements: 0,
          content: []
        };
      }
    }
  },
  methods: {
    onSearch(keyword) {
      var me = this;
      me.$ajax({
        url: "/api/help/article/search",
        params: {
          keyword: keyword,
          number: me.number,
          size: me.size,
          blength: me.blength
        }
      }).then(function(res) {
        if (res.success) {
          me.page = res.data;
        } else {
          me.page = {
            totalElements: 0,
            content: []
          };
        }
      });
    }
  }
};
</script>

<style scoped>
.page__bd {
  margin-top: 64px;
}
.search-wrp {
  background-color: var(--color-bg);
}
.search-bar {
  width: 80%;
  max-width: 960px;
  min-width: 720px;
  padding: 28px 0;
  margin: 0 auto;
}
.search-list {
  position: relative;
  padding-bottom: 100px;
  padding-top: 50px;
  box-sizing: border-box;
  width: 80%;
  max-width: 960px;
  min-width: 720px;
  margin: 0 auto;
}
.result__tips {
  font-size: 20px;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 48px;
  font-weight: 400;
}
.reco-item__link {
  display: block;
  transition: all 0.3s;
  padding: 16px;
}

.reco-item__link:hover {
  background-color: var(--color-hover);
}

.reco-item__link.active {
  background-color: var(--color-bg);
}

.reco-item__hd {
  margin-bottom: 12px;
}

.reco-item__hd h5 {
  display: inline-block;
  font-size: 14px;
  vertical-align: middle;
  font-size: 20px;
  font-weight: 600;
}

.reco__list {
  list-style: none;
}

.reco__item {
  margin-bottom: 48px;
}

.reco-item__hd .reco-item__group {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  padding: 0 5px;
  border-radius: 3px;
  border: 1px solid #222;
  vertical-align: middle;
  display: inline-block;
  transform: scale(0.84);
}

.reco-item__desc {
  color: #888;
  font-size: 16px;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 1.42;
}
</style>